import React from "react";
import tw from "tailwind-styled-components";
import { FaCheckCircle } from "react-icons/fa";
import Footer from "../Components/Checkout/Footer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const gId = useSelector(
    (state) => state.UserReducer.userDetails?.data?.data?.gId
  );
  const navigateHome = () => {
    queryClient.removeQueries("getTenantDetails");
    navigate(`/${gId}`);
  };
  return (
    <BgColor>
      <PageWrapper>
        <Container>
          <SuccessIcon>
            <IconInner>
              <FaCheckCircle className="text-white text-3xl" />
            </IconInner>
          </SuccessIcon>
          <Title>Payment Successful</Title>
          <Subtitle>
            Your due have been successfully cleared. Thank you for your payment!
          </Subtitle>
          <ProceedButton onClick={navigateHome}>Home</ProceedButton>
        </Container>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </PageWrapper>
    </BgColor>
  );
};
const Container = tw.div`flex flex-col items-center justify-center h-screen bg-white px-4`;
const SuccessIcon = tw.div`flex items-center justify-center w-32 h-32 border-4 border-green-500 rounded-full`;
const IconInner = tw.div`w-24 h-24 bg-green-600 rounded-full flex items-center justify-center`;
const Title = tw.h1`text-xl font-semibold mt-6`;
const Subtitle = tw.p`text-gray-500 text-center`;
const ProceedButton = tw.button`my-16 px-20 border border-gray-500 text-gray-500 h-11 font-normal rounded-lg text-center`;
const BgColor = tw.div`bg-zinc-100 min-h-screen flex justify-center items-center`;
const PageWrapper = tw.div`flex flex-col min-h-screen w-full mx-auto md:max-w-sm bg-white`;
const FooterWrapper = tw.div`w-full bg-gray-100 p-2`;
export default PaymentSuccess;
